import React from "react"
import { Box, Text, Container, Heading, Flex } from "@theme-ui/components"
import Breadcrumbs from "./breadcrumbs"

const ArticleTitle = ({ page }) => {
  return (
    <Container>
      <Flex sx={{ justifyContent: "center", mb: 4 }}>
        <Breadcrumbs page={page} />
      </Flex>
      <Text
        dir="invalid"
        as="h1"
        variant="h1"
        sx={{ textAlign: "center", fontSize: [5, 5, 6, 7] }}
      >
        {page.title}
      </Text>
      {page.meta && page.meta.firstPublishedAt && (
        <Box>
          <Text dir="invalid" as="p" variant="caption" sx={{ textAlign: "center", mt: 4 }}>
            {page.meta.firstPublishedAt}
          </Text>
        </Box>
      )}
    </Container>
  )
}

export default ArticleTitle
